import React from "react";
import USSDServicesLayoutHandler from "../../layouts/USSDServicesLayoutHandler";

const USSDServicesPage = () => {
  return (
    <div className="px-3">
      <USSDServicesLayoutHandler tabKey="ussd_input_logs" />
    </div>
  );
};

export default USSDServicesPage;
